var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTickIconSignup2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#1E1E1E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 10.8412L11.4571 18L8 14.7189L8.88629 13.8777L11.4571 16.3117L18.1137 10L19 10.8412Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconSignup2);
export default __webpack_public_path__ + "static/media/tickIconSignup2.d3bb5313f26c49036cae7aa545d9b6cc.svg";
export { ForwardRef as ReactComponent };